

























































import { Component, Vue } from "vue-property-decorator";
import { uploadConvertData } from "@/req/sw";
import { basePcList } from "@/components/footer/baseConfig";
import { clickBing } from "@/req/homes";
import topCom from "./components/topCom.vue";
import "./components/umeng.js";

@Component({
  components: { topCom },
})
export default class Home extends Vue {
  public active = 0;
  public list = [
    "/static/img/baseImg/swiper_one.png",
    "/static/img/baseImg/swiper_two.png",
    "/static/img/baseImg/swiper_three.png",
    "/static/img/baseImg/swiper_four.png",
    "/static/img/baseImg/swiper_five.png",
  ];
  public timer: any = null;
  public data: any = {};
  public bdVid: any = "";
  public msclkId: any = "";
  public boxUrl: any = "";
  public created() {
    if (this.$route.name == "360" || this.$route.name == "sougou") {
      let referrer = "";
      if (document.referrer.indexOf("www.baidu.com") >= 0) {
        referrer = "baidu";
      } else if (document.referrer.indexOf("www.so.com") >= 0) {
        referrer = "360";
      } else if (document.referrer.indexOf("www.sogou.com") >= 0) {
        referrer = "sougou";
      }
      const params = {
        name: "pageView",
        type: "track",
        properities: {
          pageUrl: this.$route.path,
          pagename: this.$route.name,
          webname: window.location.origin,
          pageReferer: referrer,
        },
      };
      this.$fn.bPoint(params);
    }

    if (this.$route.name == "sougou") {
      this.list = [
        "/static/img/baseImg/swiper_two.png",
        "/static/img/baseImg/swiper_four.png",
        "/static/img/baseImg/swiper_five.png",
      ];
    }
    this.bdVid = this.$route.query.bd_vid ? this.$route.query.bd_vid : "";
    const arr = basePcList.filter((item) => {
      return (
        this.$route.name == item.name || this.$route.query.isCom == item.id
      );
    });
    this.data = arr[0];
    this.boxUrl = this.data.link || this.data.pcLink;
    // 需要微软上报
    if (this.data.collectMsclkId) {
      this.msclkId = this.$route.query.msclkid ? this.$route.query.msclkid : "";
    }
  }
  public mounted() {
    setTimeout(() => {
      this.set();
    }, 1000);
    if (this.$route.name == "360") {
      this.$fn.boxCollect("baidupingzhuan_1343");
      this.$fn.boxCollect("baidupingzhuan_1344");
    }
    if (this.$route.name == "sougou") {
      this.$fn.boxCollect("baidupingzhuan_1345");
      this.$fn.boxCollect("baidupingzhuan_1346");
    }
  }
  public set() {
    this.timer = setTimeout(() => {
      this.set();
      this.autoPlay();
    }, 3000);
  }
  public autoPlay() {
    if (this.active === this.list.length - 1) {
      this.active = 0;
    } else {
      this.active++;
    }
  }
  public enter(i) {
    this.clear();
    this.active = i;
    this.set();
  }
  public clear() {
    clearTimeout(this.timer);
  }
  public sendInfo() {
    (window as any).aplus_queue.push({
      action: "aplus.record",
      arguments: ["click_download", "CLK", {}],
    });
  }
  public async uploadConver() {
    const obj: any = {
      url: process.env.NODE_ENV === "development" ? `` : window.location.href,
      type: 6,
    };
    await uploadConvertData(obj);
  }
  public download() {
    if (this.data.sendAplus) {
      this.sendInfo();
    }
    if (this.data.isSougouJs) {
      (window as any).gdt("track_custom", "CUSTOM_ACTION_NAME", {
        key1: "value1",
        key2: "value2",
      });
    }
    if (this.data.isBaiduApiToken) {
      this.bdVidDownload(this.data.isBaiduApiToken);
    } else if (this.data.collectMsclkId) {
      this.bdVidDownload();
    } else {
      window.location.href = this.data.link || this.data.pcLink;
    }
    if (this.data.isRequest) this.uploadConver();
    if (this.msclkId) this.postMsclkid();
  }
  public bdVidDownload(apiToken?: string) {
    if (this.bdVid) {
      const linkUrl = this.data.link || this.data.pcLink;
      const pcUrl: any = this.$fn.getbdVidLink(linkUrl, this.bdVid, apiToken);
      const arr = pcUrl.split("/");
      if (arr[arr.length - 1].indexOf(".exe") > 0) {
        this.downFile(linkUrl, arr[arr.length - 1]);
      } else {
        window.location.href = this.data.link || this.data.pcLink;
      }
    } else if (this.msclkId) {
      const linkUrl = this.boxUrl;
      const pcUrl: any = this.$fn.get360Link(linkUrl, this.msclkId, this.data);
      let fileName = "";
      const arr = pcUrl.split("/");
      if (arr[arr.length - 1].indexOf(".exe") > 0) {
        fileName = arr[arr.length - 1];
      }
      this.downFile(this.boxUrl, fileName);
    } else {
      window.location.href = this.data.link || this.data.pcLink;
    }
  }
  // 下载文件，自定义文件名称
  public downFile(url, fileName) {
    this.$Message.info("下载中, 请勿走开哦");
    const x = new XMLHttpRequest();
    x.open("GET", url, true);
    x.responseType = "blob";
    x.onload = () => {
      const hrefUrl = window.URL.createObjectURL(x.response);
      const a = document.createElement("a");
      a.href = hrefUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };
    x.send();
  }
  public async postMsclkid() {
    const res = await clickBing({
      type: 1,
      clickId: this.msclkId,
      deviceId: "",
      bingType: this.data.bingType,
    });
  }
}
